import { toast } from "sonner";

const KEY = "donation_nudge_at";
const WEEK = 7 * 24 * 3600 * 1000;

export function maybeDonationNudge(message, nav) {
  try {
    const last = Number(localStorage.getItem(KEY) || 0);
    if (Date.now() - last < WEEK) return;
    localStorage.setItem(KEY, String(Date.now()));
  } catch { return; }
  setTimeout(() => {
    toast(message, {
      duration: 12000,
      icon: "💚",
      action: { label: "Donate", onClick: () => nav("/donate") },
    });
  }, 900);
}
